import React from 'react';
import logo from '../../../assets/img/logos/tender-systems-logo-kruzky.png';
import { translate } from '../../shared/utils/localization-utils';

export default function Home() {
	return (
		<div className="homeComponent flex flex-col items-center justify-center w-full h-full">
			<img src={logo} alt="" className="sm:w-1/6 mb-10 animate-spin w-1/2" />
			<p className="text-2xl font-bold text-center">
				{translate('general.welcomeToReactProject')}
			</p>
		</div>
	);
}
